<div class="row mb-4">
  <div class="fw-bold fs-27 col-md-6 col-12 mt-2">
    Inquiry List
    <div class="border-green-bottom"></div>
  </div>
  <div class="col-md-6 col-12 mt-2 d-flex justify-content-md-end">
    <div class="search-area">
      <div [innerHtml]="SVG_ICONS.SEARCH_ICON() | sanitizer : 'html'" class="position-absolute mt-2 ms-2"></div>
      <input type="text" class="search-input" placeholder="Search Inquiry" (keyup)="applyFilter($event)" />
    </div>
  </div>
  <!-- <div class="col-2 mt-3">
    <button (click)="generateExcel()" class="btn btn-primary">Download Evaluation Sheet</button>
  </div>-->
  <div align="end" class="mt-2 mb-2">
    <button class="add-btn me-2 px-4 py-2" (click)="onCreateInquiry()">Add Inquiry</button>
  </div>
  <div class="table-responsive-scroll mt-4">
    <div class="mat-elevation-z8">
      <table mat-table [dataSource]="dataSource" class="w-100" matSort>
        <ng-container matColumnDef="EnquiryID">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Inquiry ID</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">#{{ item.EnquiryID }}</td>
        </ng-container>

        <ng-container matColumnDef="CreatedDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Inquiry Date</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.CreatedDate | date : "dd/MM/yyyy" }}</td>
        </ng-container>

        <ng-container matColumnDef="FirstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Name</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.FirstName }} {{ item.MiddleName }} {{ item.LastName }}</td>
        </ng-container>

        <ng-container matColumnDef="MobileNo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Mobile No.</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.MobileNo }}</td>
        </ng-container>

        <ng-container matColumnDef="Age">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Age</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.Age || "-" }}</td>
        </ng-container>

        <ng-container matColumnDef="ReferenceName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Reference Name</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.ReferenceName || "-" }}</td>
        </ng-container>

        <ng-container matColumnDef="CounsellorName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Counsellor Name</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.CounsellorName || "-" }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 20]" [length]="length" showFirstLastButtons class="mt-3"></mat-paginator>
    </div>
  </div>
</div>
